/*
 * サブシステム名：マスタ管理
 * 機能名：仕入先マスタ登録（※取引先マスタ登録ベース）
 */

import D2MSTD0020 from './D2MSTD0020.js'

export default ({
  extends: D2MSTD0020,
  name: 'MstShiiresakiEdit',
  methods: {
    // 仕入先設定
    setShiiresaki: function () {
      this.shiiresakiFlg = true
    }
  }
})
